var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTourIconActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TourIconActive_svg__clip0_90_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8E0FF",
    d: "M43.756 61.459h11.583v18.497H43.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8 62.865v17.213h-3.09V59.776h15.818v20.302h-3.09V62.865H45.8z",
    fill: "#1B264F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.442 60.365h4.512v5.632h-4.512z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.12 18.006l33.136 18.96-1.534 2.681-31.603-18.082-31.602 18.082-1.535-2.68 33.137-18.96z",
    fill: "#1B264F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.92 78.533V32.677h-3.089v48.945h48.576V32.677h-3.09v45.856H28.92z",
    fill: "#1B264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.431 73.513a1.75 1.75 0 01-1.705 1.793l-11.383.283a1.75 1.75 0 01-1.793-1.706l-.06-2.4a1.75 1.75 0 011.707-1.794m13.234 3.824l-13.234-3.824m13.234 3.824l-.06-2.401a1.75 1.75 0 00-1.792-1.706l-11.382.283m13.234 3.824l-13.234-3.824m34.47-33.02l-1.157.474 1.156-.474-.91-2.223a1.75 1.75 0 00-2.283-.956l-1.983.812c-4.192 1.718-6.634 5.229-7.303 8.987-.18 1.01.544 1.893 1.486 2.018l2.381.313.157-1.184-.156 1.184c.977.129 1.794-.558 1.966-1.423.37-1.866 1.57-3.558 3.706-4.433l1.983-.812a1.75 1.75 0 00.956-2.283zm-10.952 9.743l.255 1.224-.255-1.224c-.93.194-1.587 1.13-1.332 2.123.949 3.698 3.646 7.017 7.955 8.416 2.697.875 3.999 2.886 4.232 5.06.095.88.85 1.635 1.835 1.591l2.4-.105c.95-.042 1.747-.859 1.656-1.88-.387-4.361-3.095-8.59-8.3-10.28-2.196-.713-3.519-2.31-4.028-4.143-.236-.85-1.102-1.474-2.067-1.273l-2.351.49zm-6.863 28.766l11.882-.296c5.471-.136 9.272-3.418 10.886-7.487.378-.953-.153-1.964-1.052-2.275l-2.27-.785c-.931-.322-1.87.187-2.212 1.003-.843 2.017-2.664 3.574-5.499 3.644l-11.882.296A1.75 1.75 0 0035 71.071l.06 2.401a1.75 1.75 0 001.792 1.706z",
    fill: "#1B264F",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.657 33.436l-1.244-.413.604-1.818m.64 2.231l-.64-2.231m.64 2.231l-1.244-.413a1.875 1.875 0 001.19 2.37m.054-1.957l-.055 1.957m-.585-4.188a1.875 1.875 0 012.37-1.19m-2.37 1.19l2.37-1.19m-.433 1.306l.433-1.305 8.528 2.83a1.875 1.875 0 011.121 2.545l-3.668 8.203a1.875 1.875 0 01-2.477.946l-1.75-.782a1.875 1.875 0 01-.945-2.477l1.957-4.378-4.55-1.51m1.35-4.072l-1.35 4.072m1.35-4.072l.434-1.305m-.433 1.305l.433-1.305",
    fill: "#1B264F",
    stroke: "#fff",
    strokeWidth: 2.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TourIconActive_svg__clip0_90_1280"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16.63 17.5)",
    d: "M0 0h67v65H0z"
  })))));
}
export default __webpack_public_path__ + "media/service/TourIconActive-a46bce79.svg";
export { SvgTourIconActive as ReactComponent };